import _axios from '../plugins/axios';
// 获取考试信息
export const getExamination = id => new Promise((resolve, reject) => {
  _axios.get(`/api/examination/${id}`).then((result) => {
    resolve(result.data);
  }).catch((err) => {
    reject(err);
  });
});
// 考生登录
export const postLogin = data => new Promise((resolve, reject) => {
  _axios.post('/api/examinee/login', data).then((result) => {
    resolve(result.data);
  }).catch((err) => {
    reject(err);
  });
});
// 考生登录
export const postLogout = () => new Promise((resolve, reject) => {
  _axios.post('/api/examinee/user/logout').then((result) => {
    resolve(result.data);
  }).catch((err) => {
    reject(err);
  });
});

// 提交答案
export const postAnswer = data => new Promise((resolve, reject) => {
  _axios.post('/api/examinee/answer', data).then((result) => {
    resolve(result.data);
  }).catch((err) => {
    reject(err);
  });
});

// 再次修改答案
export const putAnswer = (id, data) => new Promise((resolve, reject) => {
  _axios.put(`/api/examinee/answer/${id}`, data).then((result) => {
    resolve(result.data);
  }).catch((err) => {
    reject(err);
  });
});

// 上传比对用视频文件,Base64格式，id是准考证号
export const postLiveRecog = (id, data) => new Promise((resolve, reject) => {
  _axios.post(`/api/examinee/${id}/liveness-recognition`, data).then((result) => {
    resolve(result);
  }).catch((err) => {
    reject(err);
  });
});

// 交卷
export const postAllPaper = id => new Promise((resolve, reject) => {
  _axios.post(`/api/examinee/${id}/hand`).then((result) => {
    resolve(result);
  }).catch((err) => {
    reject(err);
  });
});

// 获取cdn 临时密钥
export const getTmpCdnKey = () => new Promise((resolve, reject) => {
  _axios.get('/api/tentcent-cosv').then((result) => {
    resolve(result.data);
  }).catch((err) => {
    reject(err);
  });
});

// face++ 人脸检测 id 是examniation_examinee_id
export const postFaceCheck = (id, data) => new Promise((resolve, reject) => {
  _axios.post(`/api/examinee/${id}/face-check`, data).then((result) => {
    resolve(result);
  }).catch((err) => {
    reject(err);
  });
});
// 上传cdn保存的视频的链接 data {type,video_url}
export const postExaminationVideo = (id, data) => new Promise((resolve, reject) => {
  _axios.post(`/api/examinee/${id}/examination-video`, data).then((result) => {
    resolve(result);
  }).catch((err) => {
    reject(err);
  });
});

// 获取用户信息
export const getUserInfo = () => new Promise((resolve, reject) => {
  _axios.get('/api/examinee/user').then((result) => {
    resolve(result);
  }).catch((err) => {
    reject(err);
  });
});

// 获取用户时间
export const getServerTime = () => new Promise((resolve, reject) => {
  _axios.get('/api/tool/time').then((result) => {
    resolve(result.data);
  }).catch((err) => {
    reject(err);
  });
});

// 考生重置密码
export const postResetPwd = data => new Promise((resolve, reject) => {
  _axios.post('/api/examinee/reset-password', data).then((result) => {
    resolve(result.data);
  }).catch((err) => {
    reject(err);
  });
});

// 考生修改密码
export const patchEditPwd = data => new Promise((resolve, reject) => {
  _axios.patch('/api/examinee/user/password', data).then((result) => {
    resolve(result.data);
  }).catch((err) => {
    reject(err);
  });
});

// 设备检测添加
export const postDeviceCheck = data => new Promise((resolve, reject) => {
  _axios.post('/api/examinee/device-probing', data).then((result) => {
    resolve(result.data);
  }).catch((err) => {
    reject(err);
  });
});

// 设备检测修改
export const putDeviceCheck = (id, data) => new Promise((resolve, reject) => {
  _axios.put(`/api/examinee/device-probing/${id}`, data).then((result) => {
    resolve(result.data);
  }).catch((err) => {
    reject(err);
  });
});


// 获取我的考试信息,id是准考证
export const getMyExam = id => new Promise((resolve, reject) => {
  _axios.get(`/api/examination/${id}/testing`).then((result) => {
    resolve(result.data);
  }).catch((err) => {
    reject(err);
  });
});

// 技术支持
export const postTechSup = (id, data) => new Promise((resolve, reject) => {
  _axios.post(`/api/examinee/${id}/technical-support`, data).then((result) => {
    resolve(result.data);
  }).catch((err) => {
    reject(err);
  });
});
// 违规操作记录（切屏或者离线时间过长） examination_examinee_id
export const postSwitchScreen = (id, data) => new Promise((resolve, reject) => {
  _axios.post(`/api/examination/${id}/operation`, data).then((result) => {
    resolve(result.data);
  }).catch((err) => {
    reject(err);
  });
});

// 获取模拟考试题目
export const getMockExam = id => new Promise((resolve, reject) => {
  _axios.get(`/api/examination-paper/simulation/${id}/show`).then((result) => {
    resolve(result.data);
  }).catch((err) => {
    reject(err);
  });
});

// 提交C++代码到服务器,id是examination_examinee_id
export const postCodeToCompile = (id, data) => new Promise((resolve, reject) => {
  _axios.post(id ? `/api/examination/oj/${id}` : '/api/examination/oj', data).then((result) => {
    resolve(result.data);
  }).catch((err) => {
    reject(err);
  });
});
// 提交C++代码到服务器,id是上一步返回的id，轮询获取答案
export const getCompiled = id =>  new Promise((resolve, reject) => {
  _axios.get(`/api/examination/${id}/oj`).then((result) => {
    resolve(result.data);
  }).catch((err) => {
    reject(err);
  });
});
// 获取模拟题的题目,4是操作题
export const getMockQuestionByCate = (category, type = 4) =>  new Promise((resolve, reject) => {
  _axios.get(`/api/examination-paper/simulation/${category}/show`, { params: { type } }).then((result) => {
    resolve(result.data);
  }).catch((err) => {
    reject(err);
  });
});

// 第一次进入考试的时候需要请求一个接口
export const patchExamStart = id =>  new Promise((resolve, reject) => {
  _axios.patch(`/api/examination/${id}/start`).then((result) => {
    resolve(result.data);
  }).catch((err) => {
    reject(err);
  });
});
// 查看成绩
export const getSeeGrade = id => new Promise((resolve, reject) => {
  _axios.get(`/api/examination/${id}/examination-paper`).then((result) => {
    resolve(result.data);
  }).catch((err) => {
    reject(err);
  });
});
// 广告显示
export const showAd = examinationCategoryId => new Promise((resolve, reject) => {
  _axios.get(`/api/examination/${examinationCategoryId}/advert`).then((result) => {
    resolve(result.data);
  }).catch((err) => {
    reject(err);
  });
});
